<template>
    <div class="modal modal-mask" style="display: block">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{learner.first_name}} {{learner.last_name}} - Summary</h5>
                    <i class="fal fa-times" @click="$emit('close')"></i>
                </div>
                <div class="modal-body">
                    <div v-if="loaded == false" class="flex-r flex-center mt-5 mb-5">
                        <div class="flex-c flex-center"><i class='fa fa-spinner fa-spin blue fa-lg fa-fw'></i></div>
                        <div class="ml-3 flex-c flex-center">Loading...</div>
                    </div>
                    <div v-else-if="totalQuestions > 0">
                        <div class="flex-r mt-3 mb-4">
                            <div class="statsSummaryCount">
                                <div class="flex-c full-h flex-center">
                                    <div class="flex-r flex-center">{{totalComplete}} / {{totalQuestions}}</div>
                                </div>
                            </div>
                            <div class="statsSummaryBar statsSummaryBarOverall flex-c flex-center">
                                <div class="black">Overall Progress</div>
                                <div class="statsBar correct" v-bind:style="{ width: this.percent }"></div>
                            </div>
                            <div class="statsSummaryPercent statsSummaryPercentOverall">
                                <div class="flex-c full-h flex-center">
                                    <div class="flex-r flex-center statsPercentTextOverall">{{ percent }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="assignments-wrapper">
                            <label>Assignments</label>
                            <div class="assignment-row" v-for="assignment in assignments">
                                <i class="fal fa-file-alt gray large d-none d-md-block my-auto"></i>
                                <div class="d-flex flex-column mr-2 mr-sm-3 my-auto">
                                    <div class="assignment-title">{{ assignment.name }}</div>
                                    <div class="subtitle gray mb-0">{{ assignment.summary.questionCount }} Problems</div>
                                </div>
                                <div class="d-flex flex-column ml-auto text-nowrap mt-2 mt-sm-0">
                                    <div class="my-auto text-right" :style="{ color: getRemainingColor(assignment) }">
                                        {{ getAssignmentStatus(assignment) }}
                                    </div>
                                    <div v-if="assignment.summary.started" class="subtitle text-right mt-2 gray">
                                        Decisions Correct: {{assignment.summary.correctDecisionCount}} / {{assignment.summary.decisionCount}}<br>
                                        Questions Correct: {{assignment.summary.correctQuestionCount}} / {{assignment.summary.questionCount}}
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                    <div v-else class="flex-r flex-center mt-5 mb-5">
                        <div class="flex-c flex-center">There is no assignment data for this {{learner.first_name}} {{learner.last_name}}.</div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-gradient" @click="$emit('close')">{{lang['button.ok']}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['learner'],
    data() {
        return {
            assignments: [],
            student_assignments: [],
            lang: lang,
            loaded: false,
            totalQuestions: 0,
            totalComplete: 0,
            percent: 0,
            strokeColor: '#3c880c',
            strokeColors: strokeColors,
        }
    },

    mounted() {
        this.getAssignments();
    },

    methods: {
        getAssignments() {
            const {model_id, course_id, user_id} = this.learner;
            $.get('/models/' + model_id + '/assignments/'+ course_id + '/' + user_id,
            (res) => {
                this.assignments = res.assignments;
                this.student_assignments = res.student_assignments;
                this.totalQuestions = 0;
                this.totalComplete = 0;
                for(let a = 0; a < this.assignments.length; a++){
                    this.assignments[a].summary = summarizeAssignment(this.assignments[a], this.student_assignments);
                    this.totalQuestions += this.assignments[a].summary.questionCount;
                    this.totalComplete += this.assignments[a].summary.correctQuestionCount;
                }

                if(this.totalQuestions > 0) {
                    this.percent = ((this.totalComplete / this.totalQuestions) * 100).toFixed(2) + "%";
                    this.strokeColor = this.strokeColors[(Math.floor((this.totalComplete / this.totalQuestions) * 100))];

                    $(".statsSummaryBarOverall .statsBar").attr("style", "width:" + ((this.totalComplete / this.totalQuestions) * 100) + "%; background-color:" + this.strokeColor + "; border-right: 2px solid " + this.strokeColor + ";");
                    $(".statsPercentTextOverall").html(((this.totalComplete / this.totalQuestions) * 100).toFixed(2) + "%");
                }


                this.loaded = true;
            }).catch((error) => {
                bus.$emit('popupError', error);
            });
        },

        getRemainingColor(assignment) {
            return assignment.summary.complete ? '#00BD62' : !assignment.summary.started ? '#8E8D8D' : '#009EFA';
        },

        getAssignmentStatus(assignment) {
            return assignment.summary.complete ? 'Complete' : !assignment.summary.started ? 'Not started' : 'Problems Remaining: ' + (assignment.summary.questionCount - assignment.summary.correctQuestionCount);
        },

        getStyle(){
            return "width:" + this.percent + "%; background-color:" + this.strokeColor + "; border-right: 2px solid " + this.strokeColor + ";"
        }
    }
}
</script>
